import type { NavigationState, PartialState } from '@react-navigation/native';

type State = NavigationState | PartialState<NavigationState>;

export function getGuestLoginLandingState(root: State): State | undefined {
  const mainIndex = root.routes.findIndex((route) => route.name === 'main');
  const main = root.routes[mainIndex];
  const tabs = main?.state;
  if (!tabs) return;
  const billboardIndex = tabs.index ?? 0;
  const billboard = tabs.routes[billboardIndex];
  if (billboard?.name !== 'billboard' || !billboard.state) return;
  const stack = billboard.state;
  const catalogIndex = stack.routes.findIndex((route) => route.name === 'all-listings');
  if (catalogIndex < 0) return;
  const rootTop = root.routes[root.index ?? 0];
  if (rootTop?.name !== 'main' && rootTop?.name !== 'listingModal') return;
  const stackIndex = stack.index ?? 0;
  // Preserve a listing opened in the billboard stack as well as root listing modals.
  const detailRoutes = stack.routes.slice(catalogIndex + 1, stackIndex + 1);
  if (detailRoutes.some((route) => !['one-listing', 'grouped-listing'].includes(route.name))) return;
  const newBillboard = {
    ...billboard,
    state: { stale: true as const, index: detailRoutes.length, routes: [{ name: 'landing-page' }, ...detailRoutes] },
  };
  return {
    ...root,
    routes: root.routes.map((route, index) =>
      index === mainIndex
        ? {
            ...main,
            state: {
              ...tabs,
              routes: tabs.routes.map((tab, tabIndex) => (tabIndex === billboardIndex ? newBillboard : tab)),
            },
          }
        : route,
    ),
  } as State;
}
